/**
 * SQR-14053 — BNPL checkout consideration A/B test.
 *
 * The active arm comes from the LaunchDarkly flag `bnpl-experiment`, whose
 * variations are the string values below. Anything unexpected resolves to
 * `control` so a misconfigured flag can never render a half-built treatment.
 *
 * This module is deliberately telemetry-free: the experiment's event layer is
 * tracked separately and is not part of this change.
 */
export type BnplCheckoutVariant = 'control' | 'pay-later' | 'now-later';

export const BNPL_EXPERIMENT_FLAG_KEY = 'bnpl-experiment';

export const BNPL_CHECKOUT_VARIANT_CONTROL: BnplCheckoutVariant = 'control';

export const BNPL_CHECKOUT_VARIANTS: readonly BnplCheckoutVariant[] = [
  'control',
  'pay-later',
  'now-later',
];

export const parseBnplCheckoutVariant = (
  value: unknown,
): BnplCheckoutVariant => {
  if (typeof value !== 'string') return BNPL_CHECKOUT_VARIANT_CONTROL;

  return BNPL_CHECKOUT_VARIANTS.includes(value as BnplCheckoutVariant)
    ? (value as BnplCheckoutVariant)
    : BNPL_CHECKOUT_VARIANT_CONTROL;
};
